import React from 'react'
import PlayerRow from './player-row'
import GuestRow from './guest-row'

export default function PlayersTable({game, playerReservations, onUpdatePR, onEditCost, onChangeGuests, 
  onRemovePlayer, onShowPlayer, onShowPayment, onCopyPhone}) {
  const sortedPlayerReservations = playerReservations.sort((a, b) => a.team < b.team)
  const currencyName = game.currency == 'usd' ? '' : ` (${game.currency.toUpperCase()})`

  const changePlayerTeam = (pr, team) => {
    onUpdatePR({id: pr.id, team: team, guestTeams: pr.guests_distributed})
  }

  const changeGuestTeam = (pr, guestIndex, team) => {
    const guestTeams = pr.guests_distributed.map((t, i) => i == guestIndex ? team : t)
    onUpdatePR({id: pr.id, team: pr.team, guestTeams: guestTeams})
  }

  const toggleCaptain = (pr) => {
    onUpdatePR({id: pr.id, is_game_captain: !pr.is_game_captain})
  }
  
  const rows = () => {
    return sortedPlayerReservations.map(pr => { 
      const playerRow = [
        <PlayerRow 
          game={game}
          pr={pr}
          onChangeTeam={(team) => changePlayerTeam(pr, team)}
          onEditCost={onEditCost}
          onChangeGuests={onChangeGuests}
          toggleCaptain={toggleCaptain}
          onCopyPhone={() => onCopyPhone(pr.player_phone)}
          onRemove={onRemovePlayer}
          onShowPlayer={onShowPlayer}
          onShowPayment={onShowPayment}
          key={pr.id} 
        />
      ]
      if (pr.guests_number == 0) return playerRow
      
      const guestRows = pr.guests_distributed.sort().map((team, i) => {
        return <GuestRow 
          game={game} 
          pr={pr} 
          team={team} 
          index={i} 
          key={i} 
          onChangeTeam={(team) => changeGuestTeam(pr, i, team)}
          onChangeGuests={onChangeGuests}
        />
      })
      return playerRow.concat(guestRows)
    }) 
  }
  return <table className='table table-striped text-center'>
    <thead>
      <tr>
        <th>Player Name</th>
        <th></th>
        <th>Team</th>
        <th>{`Cost${currencyName}`}</th>
        <th>{`Balance${currencyName}`}</th>
        <th></th>
        <th></th>
      </tr>
    </thead>
    <tbody className='player-wrapper'>
      { 
        rows()
      }
    </tbody>
  </table>
}
